import type { DeleteAssessmentsMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import {
  DeleteAssessmentsDocument,
  namedOperations,
} from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useDeleteAssessment = createMutationHook({
  name: 'deleteAssessment',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.assessment.delete.mutationOptions({ onSuccess }),
  mapInput: (id: string) => ({ id }),
  invalidate: (trpc) => [
    // COI-889: router-level key — the hand-listed set missed `assessmentCount`,
    // the left-nav badge.
    trpc.frontend.assessment.pathKey(),
    // COI-889: the my-items ribbon counts this entity.
    trpc.frontend.myItems.pathKey(),
  ],
  // trpc should throw an error if no rows are affected
  mapResponse: (): DeleteAssessmentsMutation => ({
    delete_assessment: {
      __typename: 'assessment_mutation_response',
      affected_rows: 1,
    },
  }),
  graphqlDocument: DeleteAssessmentsDocument,
  graphqlVariables: (id: string) => ({ Ids: [id] }),
  evictFields: ['assessment', 'assessment_aggregate'],
  refetchQueries: [
    namedOperations.Query.getAssessmentById,
    namedOperations.Query.getAssessments,
  ],
});
